Item
	string id = string.undefined
	ItemType type
	string[] images
	string text
	float x, y
	int rating
	string userId
	PlainTimeString date
	bool active = true
	SpeedTest[] speedTests
	float heading, pitch
	
	// Gasoline
	float price
	
	// Media
	string[] media
	string thumbnail
	
	// Tags
	string city
	string region
	string state
	string country
	string tags
	int population
	
	// Dynamic
	float spreadX, spreadY
	float mapX, mapY
	string key
	int index
	int indexWithinGroup
	
User
	string id
	string username
	
SpeedTest
	PlainTimeString date
	string providerName
	float speed
	
enum WeatherMode: Today, NextFiveDays
		
SpeedTestFile
	string url
	int size
	
app
	const SpeedTestFile[] speedTestFiles = [
		// {url:"https://upload.wikimedia.org/wikipedia/commons/4/4d/Whole_world_-_land_and_oceans.jpg" size:  6121672}
		{url:"https://upload.wikimedia.org/wikipedia/commons/c/c1/Galaxies_Gone_Wild%21.jpg"         size: 18833412}
		{url:"https://upload.wikimedia.org/wikipedia/commons/a/a0/EpicEarth-Globespin-tilt-23.4.gif" size: 21968358}
	]
	
	const useGoogleMapsApi = true
	const minDistanceBetweenItem = 250 // In map pixels at zoom level 17, roughly equivalent to meters in south Portugal
	const queryYouTubeStart = 0
	// const queryYouTubeStart = 74
	const primaryColor = #25A5C2
	
	const topLayer = 1000000
	Vector2 editPopupSize
	float editPopupContentWidth
	DatabaseTable<Item> items = {"items"}
	Item[] currentItems
	Item editingItem, prevItem, nextItem
	ItemType[] filters = [All, Target, Night, Package, People, Gasoline, Water, Sewage, Service, Image]
	ItemType[] types = [Target, Night, Package, People, Gasoline, Water, Sewage, Service, Image, Bad]
	string editingItemImage
	HTMLElement editPopup
	User myself
	bool uploading
	
	// Current location and orientation
	Vector2 currentLocation = Vector2.none
	Angle currentOrientation
	bool orientationAvailable = false
	bool listeningToLocation = false
	bool followingLocation = false
	bool gettingLocationInProgress = false
	
	bool speedTestInProgress = false
	bool openingPopup = false
	WeatherMode weatherMode = NextFiveDays
	
	// Weather
	// Weather weather = {weather:[{id:800}{id:801}{id:802}{id:803}{id:804}{id:804}], main:{temp:27.5, feels_like:27, temp_min:25.5, temp_max:35.5}, clouds:{all:50}, wind:{speed:2.73, deg:270, gust:1.73}, sys:{sunrise:1732776622, sunset:1732805910}}
	Weather weather
	Forecast forecast
		
	init
		Platform.referenceSizes = [
			{1920}
			{480 forWidthBelow:600 isMobile:true}
		]
		
	start
		string userId = Platform.url.getBetween "token=" "&"
			myself = {id:userId}
			Platform.setLocalStorageObject "myself", myself
		else
			myself = Platform.getLocalStorageObject("myself") or {}


		html.enableScrolling false
		database.autoCancellation = false
		Platform.onPaste: onPaste .

		dynamic state = Platform.getLocalStorageObject "state"
			map.center = {x:state.center.x, y:state.center.y}
			map.zoom = state.zoom
			map.zoomLevel = map.completlyLoadedZoomLevel = math.floor(math.log2(map.zoom))
			map.filter = state.filter
			map.visibility = state.visibility
			refresh
				
		currentItems = await items.fetchAll
		spreadMedia
		refresh
		// if Platform.isDebug: openPopup currentItems.last
		
	saveState
		Platform.setLocalStorageObject "state", {map.center, map.zoom, map.filter, map.visibility}
		// print "Vector2 center = \{x:{map.center.x}, y:{map.center.y}\}"

	onPaste: DateTransfer data
		if not editingItem or openingPopup: return
		Item item = editingItem
			
		File[] filesToUpload
		bool needToUpdateMedia
		for data.items
			switch .kind
				String
					let url = await .getAsString
					string videoId, media
					if url.startsWith "https://youtu.be/"
						// Paste short YouTube-URL with optional start ime
						//     https://youtu.be/t-gnHKQCFrA?si=xtNnVDcWiBfQxY20&t=61
						videoId = media = url.getUntil "?" start:17
						int startTime = cast url.getAfter "t="
							media += "?start={startTime}"
						
					if url.startsWith "https://www.youtube.com/watch?v="
						// Paste long YouTube-URL
						//     https://www.youtube.com/watch?v=t-gnHKQCFrA
						videoId = media = url.getUntil "?" start:32
						
					if videoId
						if not item.media: item.media = []
						item.media.add media
						item.thumbnail = "https://i.ytimg.com/vi/{videoId}/default.jpg"
						needToUpdateMedia = true
						
				File
					if .type.startsWith "image/"
						// Paste image
						let file = .getAsFile
						editingItemImage = file.objectUrl
						filesToUpload.add file
		
		if needToUpdateMedia
			refresh
			await addOrUpdate item {item.media, item.thumbnail}
			
		if filesToUpload
			try
				uploading = true
				if item.type == None: item.type = Target
				currentItems.ensure item
				refresh
				await items.upload item:item files:filesToUpload
				
			catch
				alert error.stack
				
			finally
				editingItemImage = null
				uploading = false

	draw
		html.style '* {user-select:none}'
		html.documentBody.style.overflow = hidden
		div
			if editingItem or map.isFilterVisible
				div backgroundColor:black, opacity:.5, position:fixed, left:0 top:0 width:Platform.size.x, height:Platform.size.y, zIndex:topLayer-1 overlay:true pointerEvents:none
			if editingItem: drawPopup
		map.draw
		if useGoogleMapsApi: html.script "https://maps.googleapis.com/maps/api/js?key=AIzaSyCJTJ5uTIk69_ShFnLC0HwJDpl8g3TbKxg"
		// html.script "https://maps.googleapis.com/maps/api/js?key=AIzaSyAbHCFqumtHeUg8juUGpjIqSB8qWP5dT4M"
		
	drawPopup
		editPopupSize = isMobile ? {400,Platform.size.y-90} : editingItem.type == Media ? {1300,math.min(910.0, Platform.size.y-90)} : {1020,math.min(910.0, Platform.size.y-90)}
		editPopupContentWidth = editPopupSize.x - 90
		editPopup = div zIndex:topLayer backgroundColor:white borderRadius:32 position:absolute translate:(Platform.size - editPopupSize)/2 size:editPopupSize
			img Close position:absolute right:-30 top:-40 width:48 pointerEvents:none
			if prevItem: img id:"Prev" Prev position:absolute left:-30 top:50% width:48 onClick:openPopup prevItem
			if nextItem: img id:"Next" Next position:absolute right:-30 top:50% width:48 onClick:openPopup nextItem
			if editingItem.images.length > 1: img id:"Down" Down position:absolute left:50% bottom:-14 width:24
			div padding:{26 45 26 45} overflowY:scroll height:100%
				if not isMobile
					row justifyContent:center gap:2 margin:{bottom:12}
						div width:25%
							row gap:4
								drawRatingStars
							row margin:{top:12}
								drawSpeed fontSize:10
						div flex:"1"
						column alignItems:center width:40%
							row
								drawTypeIcons
							row margin:{top:8}
								drawDate fontSize:14
						div flex:"1"
						column alignItems:end width:35%
							drawPopupIcons
							row margin:{top:10}
								drawTags fontSize:10
					drawPopupText fontSize:25
					if weather != null: drawWeather
				else
					row justifyContent:center gap:2 margin:{bottom:16}
						drawTypeIcons
					row gap:12 margin:{bottom:16 left:-10 right:-10}
						drawRatingStars
						div flex:"1"
						drawPopupIcons
					row justifyContent:center
						drawSpeed fontSize:14
					drawPopupText
					if weather != null: drawWeather
					row justifyContent:center
						drawDate
					row justifyContent:center minHeight:24
						drawTags fontSize:12 showState:false

				if editingItem.images.length
					for editingItem.images as image
						div position:relative
							img src:"{database.url}/api/files/items/{editingItem.id}/{.}?thumb={isMobile ? 640 : 1920}x0" width:100%
							img Up position:absolute left:12 top:12 width:24px onClick:setPrimaryImage editingItem, image
							img Close position:absolute right:12 top:12 width:24px onClick:deleteImage editingItem, image
							img MoveOut position:absolute right:12 bottom:24 width:24px onClick:startMovingOutImage editingItem, image
							
				if editingItemImage
					img src:editingItemImage width:100%
					
				if editingItem.media
					for editingItem.media as media
						div position:relative
							html.iframe src:"https://www.youtube.com/embed/{.}" width:editPopupContentWidth height:editPopupContentWidth/16*9 allow:"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy:"strict-origin-when-cross-origin"
							img Up position:absolute left:20 top:20 width:24px onClick:setPrimaryMedia editingItem, media
							img Close position:absolute right:20 top:20 width:24px onClick:deleteMedia editingItem, media
							// img MoveOut position:absolute right:19 bottom:24 width:24px onClick:print "Move out media"
				
				drawStreeView
				
				if currentLocation
					html.iframe src:"https://www.google.com/maps/embed/v1/directions?key=AIzaSyCJTJ5uTIk69_ShFnLC0HwJDpl8g3TbKxg&origin={currentLocation.y},{currentLocation.x}&destination={editingItem.y},{editingItem.x}" width:editPopupContentWidth height:editPopupContentWidth/4*3
				
				row justifyContent:center
					div "Delete" fontSize:16 color:#a0a0a0 marginTop:8 cursor:pointer onClick:deleteItem editingItem

	// https://developer.apple.com/maps/web/
	// Currently throws WebGL exceptions
	drawAppleLookAround
		div id:"lookaround" width:editPopupContentWidth height:editPopupContentWidth/4*3
		initAppleLookAround

	js void initAppleLookAround
		// html.script "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.core.js" data:{
		// 	crossorigin:true 
		// 	async:true
		// 	// "data-callback": "initMapKit"
		// 	"data-libraries": "services,look-around"
		// 	"data-token": "eyJraWQiOiIzN0EyNVdVVzg4IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiIzSFpDTTU2NjdVIiwiaWF0IjoxNzU0ODI2NDQ2LCJleHAiOjE3NTU1MDAzOTl9.l2URj8ymQKuwNgfYX1Gn1tZjbXDQm4tgbuH5jJPlddAvPL07MUnIlJatqsyQr1ll1DFWSJpTt2p--0d_AX2lVQ"
		// }
		let element = document.getElementById('lookaround')
		if(element.children.length > 0) return
		const placeLookup = new mapkit.PlaceLookup();
		const place = await new Promise(
			resolve => placeLookup.getPlace(
				// The PlaceID that represents Cherry Hill Fountain, Central Park, New York, NY
				"IEA18943388D2216C",
				(error, result) => resolve(result)
			)
		);

		// Create an interactive look around view.
		const lookAround = new mapkit.LookAround(
			document.getElementById("lookaround"),
			new mapkit.Coordinate(app.editingItem.y, app.editingItem.x),
			{
				// Allow users to expand the view.
				showsDialogControl: true
			}
		);

	drawStreeView
		if useGoogleMapsApi
			div id:"streetview" width:editPopupContentWidth height:editPopupContentWidth/4*3
			initStreetView
		else
			html.iframe src:"https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCJTJ5uTIk69_ShFnLC0HwJDpl8g3TbKxg&location={editingItem.y},{editingItem.x}" width:editPopupContentWidth height:editPopupContentWidth/4*3
	
	js void initStreetView
		let element = document.getElementById('streetview')
		if(element.children.length > 0) return
		let panorama = new google.maps.StreetViewPanorama(element, {
			position: {lat: app.editingItem.y, lng: app.editingItem.x},
			pov: {heading: app.editingItem.heading, pitch: app.editingItem.pitch},
			motionTracking: false,
			zoomControl: false,
			addressControl: false,
			linksControl: false,
			panControl: false,
			enableCloseButton: false,
			fullscreenControl: true
		});
		panorama?.addListener("position_changed", () => {
			let pos = panorama?.getPosition()
			if(pos) app.onStreetViewPositionChanged(new Vector2(pos.lng(), pos.lat()))
		});
		let debouce
		panorama.addListener("pov_changed", () => {
			clearTimeout(debouce);
			debouce = setTimeout(() => {
				let pov = panorama?.getPov();
				if(pov) app.onStreetViewPovChanged(pov.heading, pov.pitch);
			}, 1000)
		});
		
	onStreetViewPositionChanged: Vector2 pos
		if openingPopup or not editingItem or (editingItem.x == pos.x and editingItem.y == pos.y) return
		map.cursor = pos
		// Evaluate: Disable automatically creating a new item when moving the street view cursor
		// if editingItem && editingItem.type != None
		// 	map.openPopupForCusor
		editingItem.x = pos.x
		editingItem.y = pos.y
		refresh
		
	onStreetViewPovChanged: float heading, float pitch
		if openingPopup or not editingItem or (editingItem.heading == heading and editingItem.pitch == pitch): return
		editingItem.heading = heading
		editingItem.pitch = pitch
		if editingItem.type != None
			addOrUpdate editingItem, {editingItem.heading, editingItem.pitch}		
	
	WeatherCondition[int] conditions = {
		200: {name:"thunderstorm with light rain", icon:"icons8-cloud-lightning-96.png"}
		201: {name:"thunderstorm with rain", icon:"icons8-cloud-lightning-96.png"}
		202: {name:"thunderstorm with heavy rain", icon:"icons8-cloud-lightning-96.png"}
		210: {name:"light thunderstorm", icon:"icons8-cloud-lightning-96.png"}
		211: {name:"thunderstorm", icon:"icons8-cloud-lightning-96.png"}
		212: {name:"heavy thunderstorm", icon:"icons8-cloud-lightning-96.png"}
		221: {name:"ragged thunderstorm", icon:"icons8-cloud-lightning-96.png"}
		230: {name:"thunderstorm with light drizzle", icon:"icons8-cloud-lightning-96.png"}
		231: {name:"thunderstorm with drizzle", icon:"icons8-cloud-lightning-96.png"}
		232: {name:"thunderstorm with heavy drizzle", icon:"icons8-cloud-lightning-96.png"}
		300: {name:"light intensity drizzle", icon:"icons8-rain-96.png"}
		301: {name:"drizzle", icon:"icons8-rain-96.png"}
		302: {name:"heavy intensity drizzle", icon:"icons8-rain-96.png"}
		310: {name:"light intensity drizzle rain", icon:"icons8-rain-96.png"}
		311: {name:"drizzle rain", icon:"icons8-rain-96.png"}
		312: {name:"heavy intensity drizzle rain", icon:"icons8-rain-96.png"}
		313: {name:"shower rain and drizzle", icon:"icons8-rain-96.png"}
		314: {name:"heavy shower rain and drizzle", icon:"icons8-rain-96.png"}
		321: {name:"shower drizzle", icon:"icons8-rain-96.png"}
		500: {name:"light rain", icon:"icons8-rain-cloud-96.png"}
		501: {name:"moderate rain", icon:"icons8-rain-cloud-96.png"}
		502: {name:"heavy intensity rain", icon:"icons8-rain-cloud-96.png"}
		503: {name:"very heavy rain", icon:"icons8-rain-cloud-96.png"}
		504: {name:"extreme rain", icon:"icons8-rain-cloud-96.png"}
		511: {name:"freezing rain", icon:"icons8-snow-96.png"}
		520: {name:"light intensity shower rain", icon:"icons8-rain-96.png"}
		521: {name:"shower rain", icon:"icons8-rain-96.png"}
		522: {name:"heavy intensity shower rain", icon:"icons8-rain-96.png"}
		531: {name:"ragged shower rain", icon:"icons8-rain-96.png"}
		600: {name:"light snow", icon:"icons8-snow-96.png"}
		601: {name:"snow", icon:"icons8-snow-96.png"}
		602: {name:"heavy snow", icon:"icons8-snow-96.png"}
		611: {name:"sleet", icon:"icons8-snow-96.png"}
		612: {name:"light shower sleet", icon:"icons8-snow-96.png"}
		613: {name:"shower sleet", icon:"icons8-snow-96.png"}
		615: {name:"light rain and snow", icon:"icons8-snow-96.png"}
		616: {name:"rain and snow", icon:"icons8-snow-96.png"}
		620: {name:"light shower snow", icon:"icons8-snow-96.png"}
		621: {name:"shower snow", icon:"icons8-snow-96.png"}
		622: {name:"heavy shower snow", icon:"icons8-snow-96.png"}
		701: {name:"mist", icon:"icons8-mist-96.png"}
		711: {name:"smoke", icon:"icons8-mist-96.png"}
		721: {name:"haze", icon:"icons8-mist-96.png"}
		731: {name:"sand/dust whirls", icon:"icons8-mist-96.png"}
		741: {name:"fog", icon:"icons8-mist-96.png"}
		751: {name:"sand", icon:"icons8-mist-96.png"}
		761: {name:"dust", icon:"icons8-mist-96.png"}
		762: {name:"volcanic ash", icon:"icons8-mist-96.png"}
		771: {name:"squalls", icon:"icons8-mist-96.png"}
		781: {name:"tornado", icon:"icons8-mist-96.png"}
		800: {name:"clear sky", icon:"icons8-sun-96.png"}
		801: {name:"few clouds: 11-25%", icon:"icons8-partly-cloudy-day-96.png"}
		802: {name:"scattered clouds: 25-50%", icon:"icons8-clouds-96.png"}
		803: {name:"broken clouds: 51-84%", icon:"icons8-heavy-clouds-96.png"}
		804: {name:"overcast clouds: 85-100%", icon:"icons8-triple-clouds-96.png"}
	}
	
	drawWeather
		row height:isMobile ? 120 : 160 gap:isMobile ? 0:16 justifyContent:center margin:{left:-30 right:-30} onClick:toggleWeatherMode
			// Temperate
			drawTemperature
			
			// Sunrise and Sunset
			if weather.sys != null and not isMobile
				drawWeatherItem title:"Sunrise" value:DateTime.fromTimeInSeconds(weather.sys.sunrise).hourMinuteString(German), icon:"weather/icons8-sunrise-96.png"
				drawWeatherItem title:"Sunset" value:DateTime.fromTimeInSeconds(weather.sys.sunset).hourMinuteString(German), icon:"weather/icons8-sunset-96.png"
	
			// Wind	
			if weather.wind != null and weather.wind.deg != int.undefined
				drawWind weather.wind
			
			// Current weather
			for weather.weather as item
				drawWeatherItem "Now", weather, item
				
			// Forcast for the next 4 days
			if forecast != null
				let now = DateTime.current
				for forecast.list as weather
					for .weather as item
						let time = DateTime.fromTimeInSeconds(weather.dt, outputTimezone:0)
						if weatherMode == Today
							if time.day == now.day
								drawWeatherItem "{time.hour} Uhr", weather, item
						else
						if weatherMode == NextFiveDays
							if time.hour == 15
								drawWeatherItem time.dayOfWeekShortString, weather, item
				
	toggleWeatherMode
		weatherMode = weatherMode == Today ? NextFiveDays : Today
		refresh
	
	drawWeatherItem: string text, Weather weather, WeatherItem item
		column alignItems:center
			div text fontSize:isMobile ? 13 : 15
			// img src:"https://openweathermap.org/img/wn/{item.icon}@2x.png" height:isMobile ? 50 : 70
			img src:"weather/{conditions[item.id].icon}" height:isMobile ? 30 : 40 margin:isMobile ? {top:10 bottom:10} : {top:15 bottom:15}
			column
				float fontSize = isMobile ? 9 : 14
				float iconSize = isMobile ? 13 : 18
				
				// Temperature
				row gap:4
					img Temperature width:iconSize
					div "{math.round weather.main.temp} ({math.round weather.main.feels_like})", fontSize
					
				// Sun
				row gap:4
					img Sun width:iconSize
					div "{100 - weather.clouds.all} %", fontSize
					
				// Rain
				if weather.pop != float.undefined
					row gap:4
						img Rain width:iconSize
						div "{weather.pop*100} %", fontSize
		
	drawWeatherItem: string title, string icon, string value
		column alignItems:center
			div title fontSize:isMobile ? 13 : 15
			img icon height:isMobile ? 25 : 45 margin:{top:10 left:10 bottom:15 right:10}
			div value fontSize:isMobile ? 10 : 14
		
	drawWind: WeatherWind wind
		column alignItems:center
			div "Wind" fontSize:isMobile ? 13 : 15
			img Wind height:isMobile ? 20 : 40 margin:{top:15 left:10 bottom:15 right:10} rotate:-wind.deg/360
			if wind.speed != float.undefined: div wind.speed.toString fontSize:isMobile ? 10 : 14
			if wind.gust != float.undefined:  div wind.gust.toString fontSize:isMobile ? 10 : 14
		
	drawTemperature
		column alignItems:center
			div "Temp" fontSize:isMobile ? 13 : 15 margin:{bottom:12}
			int value = weather.main.temp.round
			int minValue = weather.main.temp_min.round
			int maxValue = weather.main.temp_max.round
			float factor = isMobile ? .5 : 1
			div width:64*factor position:relative
				img TemperatureScale width:64*factor position:absolute
				img TemperatureDial width:64*factor position:absolute rotate:minValue == maxValue ? 0 : math.map value minValue to maxValue start:-.25 target:.25
				div "{value}" position:absolute fontSize:19*factor textAlign:center width:64*factor top:16*factor
				div "{minValue}" position:absolute fontSize:15*factor textAlign:center width:32*factor top:38*factor
				div "{maxValue}" position:absolute fontSize:15*factor textAlign:center width:32*factor top:38*factor left:32*factor
		
	drawTypeIcons
		for types: img src:"media/{.}.svg" width:30 title:. opacity:editingItem.type == . ? 1 : .12 onClick:clickTypeIcon .
		
	clickTypeIcon: ItemType type
		if openingPopup: return
		editingItem.type = type
		addOrUpdate editingItem, {editingItem.type}
		refresh	
		
	drawRatingStars
		let iconWidth = isMobile ? 38:32
		for 1 to 4: img i <= editingItem.rating ? FullStar : HollowStar width:iconWidth onClick:clickRatingStars i
	
	clickRatingStars: int i
		if openingPopup: return
		editingItem.rating = i==1 and editingItem.rating==1 ? 0 : i
		addOrUpdate editingItem, {editingItem.rating}
		refresh
		
	drawPopupIcons
		let iconWidth = isMobile ? 38:32
		row gap:16
			// Speed test
			img Speed width:iconWidth height:iconWidth onClick:testSpeed editingItem
			
			img Move width:iconWidth height:iconWidth onClick:startMoveItem editingItem
			
			// Directions
			// img Navigate width:iconWidth height:iconWidth onClick:clickPopupIcon "https://www.google.com/maps/dir/?api=1&destination={editingItem.y}%2C{editingItem.x}&travelmode=driving"
			img Map width:iconWidth height:iconWidth onClick:clickPopupIcon "http://maps.apple.com/?daddr={editingItem.y}%2C{editingItem.x}&dirflg=d"
			// img Navigate width:iconWidth height:iconWidth onClick:clickPopupIcon "comgooglemaps://?daddr={editingItem.y}%2C{editingItem.x}&directionsmode=driving"
			
			// Street View
			// img View width:iconWidth height:iconWidth onClick:clickPopupIcon "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={editingItem.y}%2C{editingItem.x}"
			
			// Map
			// img Map width:iconWidth height:iconWidth onClick:clickPopupIcon "https://www.google.com/maps/search/?api=1&query={editingItem.y}%2C{editingItem.x}"
			

	clickPopupIcon: string url
		if openingPopup: return
		Platform.openLink url
	
	drawPopupText: int fontSize = 20
		div
			if openingPopup
				div editingItem.text.replaced("\n" with "<br>") minHeight:fontSize+10 minWidth:editPopupContentWidth fontSize:fontSize textAlign:center margin:{bottom:12}
			else
				editableText editingItem.text outline:none tabIndex:0 flex:"1" updateWithEveryKeystroke:false minHeight:fontSize+10 minWidth:editPopupContentWidth fontSize:fontSize textAlign:center margin:{bottom:12} onChanged:addOrUpdate editingItem, {editingItem.text}
			
	drawDate: int fontSize = 12
		if editingItem.date: div editingItem.date.dayOfWeekDayMonthYearHourMinuteString() fontSize:fontSize margin:{bottom:10}
	
	drawTags: int fontSize = 9, bool showState = true
		row
			drawTag editingItem.city, fontSize
			if editingItem.region and editingItem.region != editingItem.city: drawTag editingItem.region, fontSize
			if showState and editingItem.state and editingItem.state != editingItem.city and editingItem.state != editingItem.region: drawTag editingItem.state, fontSize
			drawTag editingItem.country, fontSize
			drawTag editingItem.tags, fontSize
	
	drawTag: string text, int fontSize
		if text: div text:text fontSize:fontSize padding:{2 12 3 12} margin:{0 0 8 2} backgroundColor:primaryColor color:white borderRadius:16
	
	startCamera
		if uploading or openingPopup: return
		map.isSeachVisible = false
		map.isFilterVisible = false
		map.fileInput.click
		map.fileInput.value = ""
		refresh
					
	uploadImage: File[] files
		if uploading or openingPopup: return
		uploading = true
		Item alwaysAppendToItem = editingItem
		
		for files as file
			try
				// Get image meta data
				let meta = await Image.getMetaData(file)
				Item item
				
				if alwaysAppendToItem
					// Adding to editing item
					item = alwaysAppendToItem
					currentItems.ensure item
					print "Appending to item {item.text} {item.city}"
				else
				if map.cursor
					// Create new image at cursor position
					item = { type:Image, userId:myself.id, x:map.cursor.x, y:map.cursor.y, spreadX:map.cursor.x, spreadY:map.cursor.y }
					currentItems.add item
					alwaysAppendToItem = item
					print "Creating new item at cursor position"
				else
					let pos = meta.position or currentLocation
						// Find image at the same position
						float x = pos.x, y = pos.y
						let closestItem = currentItems.withMin (.x > x ? .x - x : x - .x) + (.y > y ? .y - y : y - .y) where (.type == Image or .type == Night or .type == Day) and .userId == myself.id
						Vector2 a = map.worldToMapPosition pos, zoomLevel:17
						Vector2 b = closestItem ? map.worldToMapPosition {closestItem.x, closestItem.y}, zoomLevel:17 : Vector2.none
						float distance = a distanceTo b
						if distance < minDistanceBetweenItem
							item = closestItem
							print "### {distance} away from {closestItem.text} {closestItem.city} -> Appending image at {pos} to item at {item.x} {item.y}"
						else
							item = { type:Image, userId:myself.id, x:pos.x, y:pos.y, spreadX:pos.x, spreadY:pos.y }
							currentItems.add item
							if closestItem: print "### {distance} away from {closestItem.text} {closestItem.city} -> Creating new item at {item.x} {item.y}"
							else            print "### No other item -> Creating new item from meta data {item.x} {item.y}"
					else
						Platform.alert "{.name} has no location meta data or there is no current location."
						continue
						
				// Date
				if not item.date
					if meta.dateTime
						item.date = meta.dateTime
						print "Setting date from meta data to {item.date}"
					else
						item.date = PlainTimeString.now
						print "Setting date to current time {item.date}"
						
				if not item.country: await lookupCityRegionStateAndCountry item
				
				item.spreadX = item.x
				item.spreadY = item.y
				if item.type == None: item.type = Target
				let image = await html.getDataUrlForFile(.)
				editingItem = item
				editingItemImage = image
				html.focusTabIndex = 0
				refresh
					
				print "start uploading image {file}"
				await items.upload item:item files:[file]
				print "finished uploading image {file} "+json.stringify item.images
				if i+1 < files.length: refresh
					
			catch
				print error.stack
			
		map.cursor = Vector2.none
		uploading = false
		editingItemImage = null
		refresh
		
	// https://www.geoapify.com/reverse-geocoding-api/
	lookupCityRegionStateAndCountry: Item item
		GeoLookupResult lookupResult = await http.get "https://api.geoapify.com/v1/geocode/reverse?lat={item.y}&lon={item.x}&apiKey=1fda6cf27e384aca9f7568ce9e2bff11"
		if lookupResult.features
			let feature = lookupResult.features.first
				if not item.text:    item.text    = feature.properties.name or ""
				if not item.city:    item.city    = feature.properties.city or ""
				if not item.region:  item.region  = map.getRegion(feature.properties)
				if not item.state:   item.state   = feature.properties.state or ""
				if not item.country: item.country = feature.properties.country or ""
				
	deleteItem: Item item
		if openingPopup: return
		if currentItems.contains(item)
			if item.type == Media
				item.active = false
				await items.update item.id, {active:false}
				spreadMedia
			else
				await items.remove editingItem
				currentItems.remove editingItem
		map.cursor = Vector2.none
		editingItem = null
		if nextItem: openPopup nextItem
		else         refresh
		
	setPrimaryImage: Item item, string image
		if openingPopup: return
		item.images.moveToFront image
		addOrUpdate item, {item.images}
		refresh
		
	setPrimaryMedia: Item item, string media
		if openingPopup: return
		item.media.moveToFront media
		item.thumbnail = "https://i.ytimg.com/vi/{media.getUntil("?")}/default.jpg"
		addOrUpdate item, {item.media, item.thumbnail}
		refresh
		
	deleteImage: Item item, string image
		if openingPopup: return
		item.images.remove image
		addOrUpdate item, {item.images}
		refresh
		
	deleteMedia: Item item, string media
		if openingPopup: return
		item.media.remove media
		addOrUpdate item, {item.media}
		refresh
		
	startMovingOutImage: Item item, string image
		if openingPopup: return
		map.moveOutImageFrom = item
		map.moveOutImage = image
		closeAndSaveItem
		
	startMoveItem: Item item
		if openingPopup: return
		map.moveItem = item
		closeAndSaveItem
		
	merge: Item from, nocolon Item into
		uploading = true
		openPopup into, animate:true
		
		try
			// Copy all images from "from" to "into"
			string[] urls
			for from.images: urls.add "{database.url}/api/files/items/{from.id}/{.}"
			await items.uploadFromUrls into, urls
			
			// Delete "from"
			await items.remove from
			currentItems.remove from
			
		catch
			alert error.message
			
		finally
			uploading = false
			map.selectedItem = null
			refresh
		
	moveOutImage: Item from, string image, nocolon Item into
		openPopup into, animate:true
		
		try
			uploading = true
			
			// Copy single image from "from" to "into"
			await items.uploadFromUrls into, ["{database.url}/api/files/items/{from.id}/{image}"]
			
			// Delete image from "from"
			removeImageAndDelteIfEmpty from, image
			
		catch
			alert error.message
			
		finally
			uploading = false
			map.selectedItem = null
			refresh
		
	moveOutImage: Item from, string image, Vector2 to
		uploading = true
		
		try
			// Create new item at position "to" and upload image
			Item newItem = { type:from.type, userId:from.userId, x:to.x, y:to.y, spreadX:to.x, spreadY:to.y }
			currentItems.add item:newItem
			openPopup newItem, animate:true
			await items.uploadFromUrls newItem, ["{database.url}/api/files/items/{from.id}/{image}"]
			
			// Delete image from "from"
			await removeImageAndDelteIfEmpty from, image
			
		catch
			alert error.message
			
		finally
			uploading = false
			map.selectedItem = null
			refresh
		
	private removeImageAndDelteIfEmpty: Item from, string image
		from.images.remove image
		if from.images
			await addOrUpdate from, {from.images}
		else
			currentItems.remove from
			await items.remove from
		
	addOrUpdate: Item item, dynamic update
		if editingItem.type == Gasoline: return
		if editingItem.type == None: editingItem.type = Target
			
		if not currentItems.contains item
			print "add "+item.toJson
			currentItems.add item
			await items.add item
		else
			print "update "+update.toJson
			await items.update item, update
		
	closeAndSaveItem
		Item item = editingItem
		if map.filter != All and item.type != None and item.type != Bad: map.filter = item.type
		if editingItem.type != None: map.cursor = Vector2.none
		map.center.x = editingItem.x
		map.center.y = editingItem.y
		editingItem = null
		editingItemImage = null
		spreadMedia
		refresh
		
	openPopup: Item item, bool animate = false
		if openingPopup: return
		editingItem = item
		let index = currentItems.indexOf(item)
		if index != -1
			nextItem = currentItems.find -> .active and .x == editingItem.x and .y == editingItem.y, startIndex:index+1
			prevItem = currentItems.find <- .active and .x == editingItem.x and .y == editingItem.y, startIndex:index-1
		else
			nextItem = null; prevItem = null
		
		if animate
			openingPopup = true
			refresh
			editPopup.animate {translate:map.worldToScreenPosition({editingItem.x, editingItem.y})-{10,10}, size:{20,20}} to {translate:(Platform.size - editPopupSize)/2, size:editPopupSize}
				duration:500 easing:"cubic-bezier(0.040, 0.380, 0.320, 1.010)"
			delay 1 seconds
				openingPopup = false
				refresh
		else
			refresh
				
		// Loopup new city, region, county
		// await lookupCityRegionStateAndCountry item
		// await items.update id:item.id {item.city, item.region, item.state, item.country}
		// print "saved new tags"
		// refresh
		
		if not Platform.isDebug: fetchWeather item.x, item.y
		// fetchWeather item.x, item.y
			
	startFollowingLocation
		followingLocation = true
		gettingLocationInProgress = true
		map.isSeachVisible = false
		map.isFilterVisible = false
		followLocation
		refresh
			
		if not listeningToLocation
			listeningToLocation = true
			
			Platform.onDeviceOrientation
				currentOrientation = .
				orientationAvailable = true
				if not editingItem: refresh
			else
				orientationAvailable = false
				
			Platform.onCurrentLocation
				currentLocation = .
				gettingLocationInProgress = false
				if followingLocation: followLocation
				if not editingItem: refresh
	
	private followLocation
		if currentLocation
			map.center = currentLocation
			if map.zoomLevel < 15: map.zoom = math.pow(2, 17)
		
	// https://creativecommons.tankerkoenig.de
	fetchGasoline
		GasolineResult result = await http.get "https://creativecommons.tankerkoenig.de/json/list.php?lat={map.center.y}&lng={map.center.x}&rad={map.widthInKm/2}&sort=price&type=diesel&apikey=b5a5b8eb-6dd4-8080-3ffe-2bb64d187dbc"
		currentItems.removeWhere.type == Gasoline
		let prices = result.stations.select(.price).distinct
		for result.stations as station
			currentItems.add {type:Gasoline, x:.lng, y:.lat, spreadX:.lng, spreadY:.lat, text:.name, id:"{.name},{.lng},{.lat}", price:.price, rating:(3-prices.indexOf(station.price)) atLeast 0}
		refresh
		
	// https://simplemaps.com/data/es-cities
	fetchCities
		if Platform.isDebug or not queryYouTubeStart: return
		string data = await http.getText "cities/es.csv"
		let lines = data.split("\n")
		for queryYouTubeStart to lines.length
			let line = lines[.]
				let cells = line.split ","
				// 0.   1.  2.  3.      4.   5.         6.      7.         8.
				// city,lat,lng,country,iso2,admin_name,capital,population,population_proper
				string city = cells[0]
				Vector2 position = new Vector2(cast cells[2], cast cells[1], geoLocation)
				string country = cells[3]
				string region = cells[5]
				string capital = cells[6]
				int population = cast cells[8]
				print "######### {i}: {city}, {region} #########"
				// if currentItems.none .city == city and .region == region and .country == country
				await fetchVideos city, region:region, country, position, population, count:16
				if (capital == "admin" or capital == "primary") and region and region != city
					// if currentItems.none .city == "" and .region == region and .country == country
					await fetchVideos region:region, country:country, position:position, population:0, count:16
				// if i >= 1: break
		// spreadMedia
		refresh
		
	listOfTags = ["", "Motorhome", "Camper Van", "Vanlife", "Nature", "Bike", "Digital Nomad"]
		
	// https://developers.google.com/youtube/v3/docs/search/list
	// https://developers.google.com/youtube/v3/determine_quota_cost
	// https://console.cloud.google.com/apis/api/youtube.googleapis.com/quotas?project=guide-438817
	fetchVideos: string city = "", string region, string country, Vector2 position, int population, int count = 10, VideoOrder order = Relevance
		if Platform.isDebug: return
		// YouTubeResult result = await http.get "https://www.googleapis.com/youtube/v3/search?part=snippet&locationRadius={radius}km&location={pos.y}%2C{pos.x}&type=video&maxResults={count}&topicId=%2Fm%2F07bxq&key=AIzaSyCJTJ5uTIk69_ShFnLC0HwJDpl8g3TbKxg&videoEmbeddable=true"
		for listOfTags as tags
			if currentItems.any .city == city and .region == region and .country == country and .tags == tags: continue
			string place = city or region
			string query = "{place} {country}"
			if tags: query += " {tags}"
			int duplicates, noPlace, added
			YouTubeResult result = await http.get "https://www.googleapis.com/youtube/v3/search?part=snippet&q={query}&relevanceLanguage=en&type=video&maxResults={count}&videoEmbeddable=true&order={order}&key=AIzaSyCJTJ5uTIk69_ShFnLC0HwJDpl8g3TbKxg"
			for result.items
				string videoId = .id.videoId
				if not .snippet.title.contains place
					noPlace++
				else
				if currentItems.any.media.contains(videoId)
					duplicates++
				else
					string text = .snippet.title.replaced("&#39;", "'").replaced("&amp;", "&")
					// BUG: Without "text" label id is set
					Item item = {type:Media media:[videoId] date:.snippet.publishedAt text:text x:position.x y:position.y thumbnail:.snippet.thumbnails.default.url city:city region:region country:country tags:tags population:population}
					await items.add item
					currentItems.add item
					added++
					print "({added.format(minIntegerDigits:2)}/{count}) {query}: {text}"
					
			print "------- ({added.format(minIntegerDigits:2)}/{count}) {query}, {duplicates} duplicates, {noPlace} don't contain the place -------"
			spreadMedia
			refresh
			await delay 1000 milliseconds
			// return result.items
		
	spreadMedia
		const minDistance = 50000
		const spiralSize = .015
		
		// Set mapX, mapY, group, indexWithinGroup
		// Collect primary items
		Item[] primaryItems
		currentItems.orderBy.rating Descending
		currentItems.each.key = "{.x},{.y}"; .spreadX = .x; .spreadY = .y; .index = i; .indexWithinGroup = 0
		let mediaItem = currentItems.where(.type == Media and .active)
		mediaItem.eachDistinct.key
			let group = i
			primaryItems.add items.first
			for items
				let mapPos = map.worldToMapPosition {.x, .y}, zoomLevel:17
				.mapX = mapPos.x
				.mapY = mapPos.y
				// .group = group
				.indexWithinGroup = i
			
		// Ensure min distance between primary items
		for 100
			let moved = false
			for primaryItems.length as a
				for a+1 to primaryItems.length as b
					let cityA = primaryItems[a]
					let cityB = primaryItems[b]
					let dx = cityB.mapX - cityA.mapX
					let dy = cityB.mapY - cityA.mapY
					let dist = math.hypot(dx, dy)
					if dist < minDistance
						let overlap = (minDistance - dist) / 2
						let angle = math.atan2(dy, dx)
						let moveX = math.cos(angle) * overlap
						let moveY = math.sin(angle) * overlap
						cityA.mapX -= moveX; cityA.mapY -= moveY
						cityB.mapX += moveX; cityB.mapY += moveY
						moved = true
			if not moved: break

		// Arrange in spiral
		Vector2 circleSize = ({map.max.x-map.min.x, map.max.y-map.min.y}/Platform.size).normalized
		mediaItem.eachDistinct.key
			float theta
			let firstItem = items.first
			let pos = map.mapToWorldPosition {firstItem.mapX, firstItem.mapY} zoomLevel:17
			for items
				theta +=  4 / math.sqrt(1 + theta * theta)
				let r = spiralSize * theta;
				.spreadX = pos.x - r * math.cos(theta)*circleSize.x
				.spreadY = pos.y - r * math.sin(theta)*circleSize.y
				
	// makeListShorterForDebugging
	// 	currentItems.removeWhere.indexWithinGroup > 0 or .type != Media
	// 	string str
	// 	for currentItems
	// 		let pos = map.worldToMapPosition {.x, .y}, zoomLevel:17
	// 		if pos.y < 13162000 and .city
	// 			if str: str += ", "
	// 			str += "\{x:{math.floor pos.x}, y:{math.floor pos.y}, name:\"{.city}\"\}"
	// 	print "let items = [{str}]"
		
	// spreadMedia
	// 	currentItems.where(.type == Media).eachDistinct("{.x},{.y}")
	// 		items.orderBy.rating Descending
	// 		spreadCircle items[..7], radius:.2
	// 		if items.length > 7: spreadCircle items[7..21], radius:.45
	// 		if items.length > 21: spreadCircle items[21..], radius:.7
				
	// spreadCircle: Item[] items, radius = .2
	// 	for items
	// 		Vector2 circleSize = ({map.max.x-map.min.x, map.max.y-map.min.y}/Platform.size).normalized * radius
	// 		float angle = i/items.length
	// 		.spreadX = .x + math.sin(angle)*circleSize.x
	// 		.spreadY = .y - math.cos(angle)*circleSize.y
	
	// https://openweathermap.org/price
	// https://openweathermap.org/current
	// https://openweathermap.org/forecast5
	fetchWeather: float x, float y
		weather = await http.get "https://api.openweathermap.org/data/2.5/weather?lat={y}&lon={x}&units=metric&lang=de&appid=9fdd7c05d6838ea179bdc458a685c0dd"
		forecast = await http.get "https://api.openweathermap.org/data/2.5/forecast?lat={y}&lon={x}&units=metric&lang=de&appid=9fdd7c05d6838ea179bdc458a685c0dd"
		refresh
		print forecast.toJson
		
	drawSpeed: int fontSize = 9
		if speedTestInProgress
			img inProgressC height:isMobile ? 38 : 32 margin:{-6 0 0 4}
		else
		if editingItem.speedTests
			Set<string> keys = {}
			for editingItem.speedTests backwards as test
				if not keys[test.providerName]
					keys.add test.providerName
					div text:"{test.providerName}: {test.speed.format(fractionDigits:1)}" fontSize:fontSize padding:{2 12 3 12} margin:{0 0 8 2} backgroundColor:primaryColor color:white borderRadius:16
		else
		if not isMobile
			div text:"Speed-Test" fontSize:fontSize padding:{2 12 3 12} margin:{0 0 8 2} backgroundColor:primaryColor color:white borderRadius:16 onClick:testSpeed editingItem
	
	// https://ipify.org
	// https://jsonip.com
	// https://ipinfo.io
	testSpeed: Item item
		try
			if speedTestInProgress or openingPopup: return
			speedTestInProgress = true
			refresh
			JsonIPResult jsonIP
			IPInfoResult ipInfo
			
			// Get IP
			try   jsonIP = await http.get "https://api.ipify.org?format=json"
			catch alert "Failed to get ip address.\n{.message}"
			try   ipInfo = await http.get "https://ipinfo.io/{jsonIP.ip}?token=7932c7f7701b5b"
			catch alert "Failed to get ip info.\n{.message}"
				
			print jsonIP?.ip, json.stringify ipInfo
			string providerName
			string[] providerParts = ipInfo.org.split " "
			for 1 to providerParts.length
				let name = providerParts[.]
				if not name.toLowerCase.startsWith("deutsch"): providerName = name; break
			// let info = Platform.networkInformation
			// if info?.type: providerName += " {info.type.capitalize()}"
			let speed = await testSpeedCore
			if not item.speedTests: item.speedTests = []
			item.speedTests.add {date:PlainTimeString.now, providerName, speed}
			if currentItems.contains item
				await items.update item, {item.speedTests}
				
		finally 	
			speedTestInProgress = false
			refresh
			
	testSpeedCore
		float startTime = float.preciseTime
		float totalTime
		int totalSize
		for 10
			for speedTestFiles as file
				try
					let result = await http.getArrayBuffer "{.url}?do_not_cache={randomFloat}"
					totalSize += result.byteLength
					totalTime = float.preciseTime - startTime
					if Platform.isDebug: print "{totalTime} ms: {.url} -> {result.byteLength} vs {.size}"
					if totalTime > 10 seconds
						return totalSize * 0.007629394531 / totalTime
						
				catch 
					alert "Filed to load {file.url}\n{.message}"
					
		return totalSize * 0.007629394531 / totalTime

WeatherCondition
	string name
	string icon
	
// https://jsonip.com	
interface JsonIPResult
	string ip // 95.90.247.34

// https://ipinfo.io/95.90.247.34?token=7932c7f7701b5b
// https://ipinfo.io/account/home
interface IPInfoResult
	string ip // 95.90.247.34
	string hostname // ip5f5af722.dynamic.kabel-deutschland.de
	string city // Berlin
	string region // Berlin
	string country // DE
	string loc // 52.5244,13.4105
	string org // AS3209 Vodafone GmbH
	string postal // 10119
	string timezone // Europe/Berlin
	
class Forecast
	Weather[] list
	
class Weather
	float dt
	string dt_txt
	WeatherItem[] weather
	string base
	WeatherMain main
	float visibility
	WeatherWind wind
	WeatherClouds clouds
	dynamic rain
	WeatherSys sys
	float pop
	
class WeatherItem
	int id
	string main
	string description
	string icon
	
class WeatherMain
	float temp
	float feels_like
	float temp_min
	float temp_max
	float pressure
	float humidity
	float sea_level
	float grnd_level

class WeatherWind
	float speed
	float gust
	int deg
	
class WeatherClouds
	int all
	
class WeatherSys
	string country
	float sunrise
	float sunset
			
interface GasolineResult
	bool ok
	string glicense
	string data
	string status
	GasolineStation[] stations

interface GasolineStation
	string id
	string name
	string brand
	string street
	string place
	float lat
	float lng
	float dist
	float price
	bool isOpen
	string houseNumber
	int postCode
	
interface YouTubeResult
	YouTubeVideo[] items
	
interface YouTubeVideo
	YouTubeId id
	YouTubeSnippet snippet
	
interface YouTubeSnippet
	PlainTimeString publishedAt
	string channelId
	string title
	string description
	YouTubeThumbnailSet thumbnails
	string channelTitle
	string liveBroadcastContent
	string publishTime
	
interface YouTubeThumbnailSet
	YouTubeThumbnail default
	YouTubeThumbnail medium
	YouTubeThumbnail high
	
interface YouTubeThumbnail
	string url
	int width
	int height
	
interface YouTubeId
	string kind
	string videoId
	
interface GeoLookupResult
	GeoLookupFeature[] features
	
interface GeoLookupFeature
	string type
	GeoLookupProperties properties
	
interface AutocompleteResult
	GeoLookupProperties[] results
	
class GeoLookupProperties
	string country_code
	string name
	string housenumber
	string street
	string country
	string county
	dynamic datasource
	string postcode
	string state
	string district
	string suburb
	string city
	string state_code
	float lon
	float lat
	float distance
	string result_type
	string formatted
	string address_line1
	string address_line2
	dynamic timezone
	string plus_code
	string plus_code_short
	dynamic rank
	string place_id
	
enum lowercase string VideoOrder
	Date // Resources are sorted in reverse chronological order based on the date they were created.
	Rating // Resources are sorted from highest to lowest rating.
	Relevance // Resources are sorted based on their relevance to the search query. (default)
	Title // Resources are sorted alphabetically by title.
	VideoCount // Channels are sorted in descending order of their number of uploaded videos.
	ViewCount // Resources are sorted from highest to lowest number of views.
	
Bounds
	Vector2 min
	Vector2 max
	
	toString := "min:{min} max:{max}"
	center := {(min.x + max.x)/2, (min.y + max.y)/2}
	
enum Visibility: Public, Private
enum string ItemType: None, All, Media, Target, Package, Image, Night, Day, Water, Sewage, People, Gasoline, Service, Bad
	
map
	const earthRadius = 6378137
	const maxLatitude = 85.0511287798
	const Vector2 tileSize = {256,256}
	const float minZoom = math.pow(2, 2)
	const float maxZoom = math.pow(2, 20)
	const Color[ItemType] colorForType = {
		Target: #16C66E
		Night: #1B6FB3
		Package: #F7AD00
		People: #BA6BD3
		Gasoline: #FF8C26
		Water: #5D57DA
		Sewage: #D27D52
		Image: #25A5C2
		Service: #747474
		Media: #D20707
		Bad: #EF476F
	}
		
	const iconSize = 84
	const maxItemSize = 120
	
	Vector2 center = {x: 13.460430551253582, y: 52.50390613458058} // Berlin
	// Vector2 center = {x:-3.654678758313643, y:40.36952979606146} // Madrid
	// Vector2 center = {x:3.1818347838355217, 47.394591731558904} // France
	// Vector2 center = {x:-5.222185248634108, y:36.92129748547718} // Andalusia
	// Vector2 center = {x:-8.107612657275922, y:37.231321546319585} // Faro
	// Vector2 center = {x:-8.412685250885627, y:37.089850622036046} // Portugal Beach
	// Vector2 center = {-8.2970742, 37.0730365} // Portugal Beach
	// Vector2 center = {x:6.924099177240271, y:43.466017359824264} // Côte d’Azur
	Vector2 min, max
	int zoomLevel = 12
	int completlyLoadedZoomLevel = zoomLevel
	float zoom = math.pow(2, zoomLevel)
	Vector2 cursor = Vector2.none
	Item selectedItem
	HTMLElement fileInput
	float widthInKm
	
	// Move
	Item moveItem
	string moveOutImage
	Item moveOutImageFrom
	
	bool isFilterVisible = false
	ItemType filter = All
	Visibility visibility = Private
	
	// Convert world (x: longiture, y:latitude) to map position (pixels within world map)
	worldToMapPosition: Vector2 worldPos, int zoomLevel
		let d = math.pi / 180
		let sin = math.sin(math.max(math.min(maxLatitude, worldPos.y), -maxLatitude) * d)
		let projectedPoint = Vector2(earthRadius * worldPos.x * d, earthRadius * math.log((1 + sin) / (1 - sin)) / 2)
		let scale = 256 * math.pow(2, zoomLevel)
		let s = 0.5 / (math.pi * earthRadius)
		let transformedPoint = Vector2(scale * (s * projectedPoint.x + .5), scale * (-s * projectedPoint.y + .5))
		return transformedPoint
		
	// Convert map (pixels within world map) to world position (x: longiture, y:latitude)
	mapToWorldPosition: Vector2 mapPos, int zoomLevel
		let scale = 256 * math.pow(2, zoomLevel)
		let s = 0.5 / (math.pi * earthRadius)
		let untransformedPoint = Vector2((mapPos.x / scale - .5) / s, (mapPos.y / scale - .5) / -s)
		let d = 180 / math.pi
		let projectedPoint = Vector2(untransformedPoint.x * d / earthRadius, (2 * math.atan(math.exp(untransformedPoint.y / earthRadius)) - (math.pi / 2)) * d, geoLocation)
		return projectedPoint
	
	// Convert world (x: longiture, y:latitude) to screen position (origin is topleft)
	worldToScreenPosition: Vector2 worldPos
		let zoomBase = math.pow(2, zoomLevel)
		let zoomWithin = 1+(zoom-zoomBase)/zoomBase
		return Platform.size/2 + (worldToMapPosition(worldPos, zoomLevel) - worldToMapPosition(center, zoomLevel))*zoomWithin
	
	// Convert screen (origin is topleft) to world position (x: longiture, y:latitude)
	screenToWorldPosition: Vector2 screenPos
		let zoomBase = math.pow(2, zoomLevel)
		let zoomWithin = 1+(zoom-zoomBase)/zoomBase
		return mapToWorldPosition(worldToMapPosition(center, zoomLevel) + (screenPos - Platform.size/2)/zoomWithin, zoomLevel)
		
	// Scales screen (origin is topleft) to world scale (aplies zoom, but ignores offset)
	screenToWorldScale: Vector2 screenPos
		Vector2 screenToWorldFactor = Platform.size / (max - min)
		return (screenPos - Platform.size/2) / screenToWorldFactor.inverse
	
	Vector2 touchStartPosition
	Vector2 panCenter
	float startDistanceToSecondTouch
	float startZoom
	bool zoomingOrPanning = false

	draw
		div overflow:hidden width:Platform.size.x height:Platform.size.y
			// Map
			div position:absolute width:Platform.size.x height:Platform.size.y
				zoomLevel = math.floor(math.log2(zoom))
				let loadedCompletely = drawAtZoomLevel zoomLevel
				if not loadedCompletely and math.abs(zoomLevel - completlyLoadedZoomLevel) == 1
					drawAtZoomLevel completlyLoadedZoomLevel, zIndex:-1
				else
					completlyLoadedZoomLevel = zoomLevel
					
			// Filter items
			Item[] filteredItems
			int skip = zoom < 200 ? 8 : zoom < 300 ? 4 : zoom < 500 ? 2 : 1
			for app.currentItems
				if .active and ((.indexWithinGroup mod skip) == 0) and (filter == All or .type == filter) and (visibility == Public or .userId == app.myself.id) and min.x <= .spreadX <= max.x and max.y <= .spreadY <= min.y
					filteredItems.add .
			
			div position:absolute
				// Cursor
				if cursor: img Marker id:"Cursor" key:"cursor" width:82 margin:{top:-81 left:-25} position:absolute translate:worldToScreenPosition(cursor) zIndex:2 data:{draggable:false}
				
				// Current Location
				if app.currentLocation: img app.orientationAvailable ? LocationAndOrientation : Location id:"CurrentLocation" key:"currentLocation" margin:{top:-50 left:-50} width:100 height:100 position:absolute translate:worldToScreenPosition(app.currentLocation) rotate:app.currentOrientation zIndex:1 data:{draggable:false}
				
				// Polygon
				for polygon as point
					print "drawing polygon point {point}"
					img Marker width:82 margin:{top:-81 left:-25} position:absolute translate:worldToScreenPosition(point) zIndex:2 data:{draggable:false}
					
				// Items
				float zoomFactor = 1 interpolateTo 2 progress:zoom/32768
				float imageWidth = maxItemSize * zoomFactor
				for filteredItems backwards as item
					let pos = worldToScreenPosition(.spreadX or .spreadY ? {.spreadX, .spreadY} : {.x, .y})
					if item.type == Bad
						div position:absolute translate:pos margin:{top:-16 left:-15} key:item.id or math.randomString() id:"Item{item.id}" zIndex:app.currentItems.length-.index data:{draggable:false}
							img Bad position:absolute, width:32, data:{draggable:false}
					else
					if .images.length > 0 or .thumbnail or item.type == Gasoline
						let src = "{database.url}/api/files/items/{.id}/{.images.first}?thumb=200x200"
						div position:absolute translate:pos margin:{left:-imageWidth/2 top:-imageWidth/2} key:item.id or math.randomString() id:"Item{item.id}" zIndex:app.currentItems.length-.index, data:{draggable:false}, opacity:item.type == Gasoline and .rating == 0 ? .33 : 1
							if .images.length > 0
								img src width:imageWidth height:imageWidth borderRadius:50% position:absolute border:{10*zoomFactor colorForType[.type] selectedItem == item ? dotted : solid}, data:{draggable:false}
							else
							if .thumbnail
								div width:imageWidth height:imageWidth borderRadius:50% position:absolute backgroundImage:new Image(src:item.thumbnail basePath:"") backgroundSize:"cover" border:{10*zoomFactor colorForType[.type]}, data:{draggable:false}
							else
							if item.type == Gasoline
								// let price = item.price ? (item.price*90).round.toString : "" 
								div display:flex flexDirection:column justifyContent:center alignItems:center fontSize:40*zoomFactor fontWeight:1000 textAlign:center width:imageWidth height:imageWidth borderRadius:50% position:absolute backgroundImage:GasolineItem  border:{10*zoomFactor colorForType[.type]}, data:{draggable:false}, color:black
									div item.price.format(fractionDigits:2) margin:{bottom:-8} data:{draggable:false}
									div "90l: {(item.price*90).round}", fontSize:20*zoomFactor data:{draggable:false}
							if .rating:	img Rating[.rating-1] width:140 position:absolute translate:{-10*zoomFactor, -10*zoomFactor} width:140*zoomFactor data:{draggable:false}
					else
						div position:absolute translate:pos margin:{top:-81 left:-25} key:item.id or math.randomString() id:"Item{item.id}" zIndex:app.currentItems.length-.index data:{draggable:false}
							img Marker position:absolute, width:82, data:{draggable:false}
							if .rating:	img TargetRating[.rating-1] width:84 position:absolute translate:{-17, -18} data:{draggable:false}
			
			div
				drawToolbar
			
		..onTouchDown
			element.captureTouch .
			let firstTouch = touches.first
			let secondTouch = touches.second
				startDistanceToSecondTouch = firstTouch.position distanceTo secondTouch.position
				startZoom = zoom
				zoomingOrPanning = true
			
			panCenter = center - screenToWorldScale(firstTouch.position)
			touchStartPosition = firstTouch.position
			// refresh
			
		..onTouchMove
			let firstTouch = touches.first
			let secondTouch = touches.second
				zoom = (startZoom * (firstTouch.position distanceTo secondTouch.position)  / startDistanceToSecondTouch) clamp minZoom to maxZoom
				
			center = screenToWorldScale(firstTouch.position) + panCenter
			if firstTouch.position distanceTo touchStartPosition > 16
				zoomingOrPanning = true
				app.followingLocation = false
			removeCursorIfScrolledOffScreen
			refresh
			// print center, zoomLevel
			
		..onTouchUp
			if touches.length == 1
				// If the user lifts the first touch and a second touch is still down
				// start panning with the second touch, which will become the first touch in the next frame
				let firstTouch = touches.first
				panCenter = center - screenToWorldScale(firstTouch.position)
				zoomingOrPanning = true
			else
			if touches.length == 0
				if not zoomingOrPanning
					if .touchedId == "Camera":               app.startCamera; else
					if app.editingItem:                      app.closeAndSaveItem; else
					if .touchedId == "Visibility":           clickVisibility; else
					if .touchedId == "FollowingLocation":    app.startFollowingLocation; else
					if .touchedId == "ShowSearch":           showSearch true; else
					if .touchedId == "HideSearch":           showSearch false; else
					if .touchedId == "Cursor":               openPopupForCusor; else
					if .touchedId.startsWith "SearchResult": clickSearchResult cast .touchedId[12..]; else
					if .touchedId.startsWith "Filter":       clickFilter cast .touchedId[6..]; else
					if isFilterVisible:                      isFilterVisible = false; refresh; else
					if .touchedId.startsWith "Item":         clickItem .touchedId[4..], merge:.metaKey; else
					if .touchedId != "SearchQuery":         
						if isSeachVisible:                   showSearch false
						else                                 clickLocation screenToWorldPosition(.position), move:.metaKey
				zoomingOrPanning = false
				app.saveState
				
		..onScroll
			if isPinch
				// Zoom
				let prevZoom = zoom, prevCenter = center
				Vector2 worldPos = screenToWorldPosition(position)
				zoom = (zoom / math.exp(delta.y*.001)) clamp minZoom to maxZoom
				center = worldPos + (center-worldPos)*(prevZoom/zoom)
			else
				// Pan
				center = center - delta / zoom*2
			removeCursorIfScrolledOffScreen
			app.followingLocation = false
			app.saveState
			refresh
			
	bool isSeachVisible = false
	GeoLookupProperties[] searchResults
	string seachQuery = ""
	int selectedSeachResult = -1
	
	// Data for testing
	// bool isSeachVisible = false
	// string seachQuery = "Sevilla Plaza de"
	// GeoLookupProperties[] searchResults = [
	// 	{formatted:"Plaza de España, Sevilla, Spain" }
	// 	{formatted:"Plaza de toros La Maestranza de Sevilla, Sevilla, Spain" }
	// 	{formatted:"Plaza de toros de la Real Maestranza de Caballería de Sevilla, Sevilla, Spain" }
	// ]
	// int selectedSeachResult = 1
	
	drawToolbar
		if not app.editingItem
			// Upper Left: Search
			if not isSeachVisible
				// Icon
				img id:"ShowSearch" Search position:absolute left:20 top:20 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
			else
				// Results
				if searchResults
					column zIndex:app.topLayer left:20 top:20 width:440 fontSize:18 padding:{80 0 16 0} backgroundColor:white position:absolute borderRadius:32 boxShadow:{blur:30 color:#00000060}
						for searchResults as seachResult
							string id = "SearchResult{i}"
							bool isSelected = i == selectedSeachResult
							row alignItems:start id:id backgroundColor:isSelected ? app.primaryColor : white padding:{top:12 bottom:12 left:32 right:32}
								img isSelected ? TargetLight : TargetDark id:id width:12 margin:{top:1 right:16}
								div cursor:pointer id:id
									string a, b
									int commaIndex = .formatted.indexOf(", ")
									if commaIndex != -1: a = .formatted[..commaIndex]; b = .formatted[commaIndex+2..]
									else                 a = .formatted
									div tag:"span" id:id a color:isSelected ? white : black
									div tag:"span" id:id b margin:{left:8} color:isSelected ? #ffffff80 : #b0b0b0
									
				// Query
				row id:"HideSearch" zIndex:app.topLayer width:440 left:20 top:20 height:64 backgroundColor:white position:absolute borderRadius:32 boxShadow:{blur:30 color:#00000060} alignItems:center
					img id:"HideSearch" SearchPlain width:50 margin:{left:6 right:12}
					editableText id:"SearchQuery" fontSize:20 tabIndex:1 width:100% seachQuery updateWithEveryKeystroke:true outline:none onKeyDown:onSeachQueryKeyDown(.) onChanged:search
					img id:"HideSearch" HideSearch width:20 margin:{left:12 right:20} cursor:pointer
				
			// Lower Left: Filter icons
			if isFilterVisible
				for app.filters
					drawFilterIcon . index:i showName:true
			else
				drawFilterIcon filter
			
			// Lower Right: Toolbar
			if not isSeachVisible
				img id:"Visibility" visibility == Public ? Public : Private position:absolute left:Platform.size.x-92 top:20 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
			
			if app.gettingLocationInProgress
				img inProgressC position:absolute left:Platform.size.x-97 top:Platform.size.y-170 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
			else
				img id:"FollowingLocation" FollowingLocation position:absolute left:Platform.size.x-92 top:Platform.size.y-170 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
		
		fileInput = html.fileInput display:none multiple:true onChange:app.uploadImage .files
		if app.uploading
			img inProgressC position:absolute left:Platform.size.x-97 top:Platform.size.y-100 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
		else
			img id:"Camera" Camera position:absolute left:Platform.size.x-92 top:Platform.size.y-100 width:iconSize height:iconSize zIndex:app.topLayer+1, data:{draggable:false}
		
	int debounceSearch
	
	// https://www.geoapify.com/address-autocomplete/
	search
		Platform.clearDelay debounceSearch
		debounceSearch = delay 700 milliseconds
			AutocompleteResult result = await http.get "https://api.geoapify.com/v1/geocode/autocomplete?text={Platform.encodeURIComponent(seachQuery)}&format=json&apiKey=1fda6cf27e384aca9f7568ce9e2bff11"
			searchResults = result.results
			selectedSeachResult = 0
			refresh
			
	onSeachQueryKeyDown: HtmlKeyboardEvent ev
		if ev.keyCode == Up and selectedSeachResult > 0: selectedSeachResult--; ev.preventDefault(); refresh; else
		if ev.keyCode == Down and selectedSeachResult < searchResults.length-1: selectedSeachResult++; ev.preventDefault(); refresh; else
		if ev.keyCode == Enter and 0 <= selectedSeachResult < searchResults.length: ev.preventDefault(); clickSearchResult(selectedSeachResult); else
		if ev.keyCode == Escape: showSearch false
			
	clickSearchResult: int index
		let seachResult = searchResults[index]
		selectedSeachResult = index
		center = cursor = {x:seachResult.lon, y:seachResult.lat}
		zoom = math.pow(2, 16)
		isSeachVisible = false
		Item item = {text:seachResult.name or seachResult.address_line1 or "", city:seachResult.city or "", region:getRegion(seachResult), state:seachResult.state or "", country:seachResult.country or "", date:PlainTimeString.now, x:cursor.x, y:cursor.y, spreadX:cursor.x, spreadY:cursor.y, userId:app.myself.id}
		app.openPopup item animate:true
		refresh
		
	getRegion: GeoLookupProperties p
		return p.district and p.district != p.city ? p.district : p.county and p.county != p.city ? p.county : (p.suburb or "")
		
	showSearch: bool value = true
		isSeachVisible = value
		seachQuery = ""
		selectedSeachResult = -1
		html.focusTabIndex = 1
		searchResults.clear
		isFilterVisible = false
		refresh
		
	clickItem: string id, bool merge
		Item item = app.currentItems.find.id == id
		if moveItem
			app.merge moveItem into item
			moveItem = null
		else
		if moveOutImage
			app.moveOutImage moveOutImageFrom, moveOutImage into item
			moveOutImage = null
			moveOutImageFrom = null
		else
		if not merge
			selectedItem = null
			app.openPopup item, animate:true
		else
			if not selectedItem
				selectedItem = item
				refresh
			else
			if selectedItem != item
				app.merge selectedItem into item
					
	clickLocation: Vector2 position, bool move
		isSeachVisible = false
		if drawingPolygon
			polygon.add position
			print "adding point {position} to polygon {polygon.length}"
			refresh
		else
		if moveItem
			moveItem.x = moveItem.spreadX = position.x
			moveItem.y = moveItem.spreadY = position.y
			moveItem = null
			refresh
		else
		if moveOutImage
			app.moveOutImage moveOutImageFrom, moveOutImage to position
			moveOutImage = null
			moveOutImageFrom = null
		else
		if not move
			cursor = position
			openPopupForCusor
		else
		if selectedItem
			selectedItem.x = selectedItem.spreadX = position.x
			selectedItem.y = selectedItem.spreadY = position.y
			refresh
			
	openPopupForCusor
		Item item = { type:None, userId:app.myself.id, date:PlainTimeString.now, x:cursor.x, y:cursor.y, spreadX:cursor.x, spreadY:cursor.y }
		app.openPopup item, animate:false
		await app.lookupCityRegionStateAndCountry item
		selectedItem = null
		refresh
			
	removeCursorIfScrolledOffScreen
		if cursor and not(min.x <= cursor.x <= max.x and max.y <= cursor.y <= min.y)
			cursor = Vector2.none
			
	clickVisibility
		visibility = visibility == Public ? Private : Public
		isSeachVisible = false
		isFilterVisible = false
		app.saveState
		refresh
			
	clickFilter: ItemType filter
		if not isFilterVisible
			isFilterVisible = true
			if isSeachVisible: showSearch false
		else
			this.filter = filter
			isFilterVisible = false
			if filter == Gasoline: visibility = Public; app.fetchGasoline; else
			if filter == Media and app.queryYouTubeStart: visibility = Public; app.fetchCities
			app.saveState
		refresh
	
	drawFilterIcon: ItemType filter, int index = 0, bool showName = false
		div id:"Filter{filter}" position:absolute left:20 top:Platform.size.y-100-index*70 width:iconSize height:iconSize zIndex:app.topLayer+1 backgroundImage:Shadow backgroundSize:"cover"
			img src:"media/{filter}.svg" width:50 margin:{left:11 top:10}
			if showName: div text:filter == "Image" ? "Sight" : filter margin:{left:80 top:-50} fontSize:20 color:white
				
	drawAtZoomLevel: int zoomLevel, int zIndex = 0
		let zoomBase = math.pow(2, zoomLevel)
		let zoomWithin = 1+(zoom-zoomBase)/zoomBase
		let pixelCenter = worldToMapPosition(center, zoomLevel)
		let halfSize = Platform.size / 2
		let pixelBounds = Bounds(pixelCenter - halfSize/zoomWithin, pixelCenter + halfSize/zoomWithin)
		let tileRange = Bounds(pixelBounds.min / tileSize, pixelBounds.max / tileSize)
		let tileCenter = tileRange.center
		let zoomedSize = tileSize * zoomWithin
		let zoomedSizeWithOverlap = zoomedSize * 1.001
		let loadedCompletely = true
		min = screenToWorldPosition({-maxItemSize, -maxItemSize})
		max = screenToWorldPosition({Platform.size.x + maxItemSize, Platform.size.y + maxItemSize})
		widthInKm = (pixelBounds.max.x - pixelBounds.min.x) * (94.6773333333/zoomBase)
		
		for tileRange.min.y.floor to tileRange.max.y.ceil as y
			for tileRange.min.x.floor to tileRange.max.x.ceil as x
				Vector2 pos = halfSize + ({x,y}-tileCenter) * zoomedSize
				let src = "https://tile.openstreetmap.org/{zoomLevel}/{x}/{y}.png"
				let node = img src key:src position:absolute, translate:pos, size:zoomedSizeWithOverlap, zIndex, data:{draggable:false}
				if not node.complete: loadedCompletely = false
						
		return loadedCompletely

	bool drawingPolygon = false
	Vector2[] polygon


